<template>
  <q-page padding>
    <div style="align-items: center" class="row col-12">
      <p class="text-h6 text-brand-1 text-weight-bold">Logs do Setup</p>
    </div>
    <div class="row text-brand-5 text-weight-bold q-mt-md">
      <div class="q-ml-sm col-md-2">
        <div class="input-new-design">Unidade</div>
        <lista-unidades-select v-model="unidade" />
      </div>

      <div class="q-ml-sm col-md-2">
        Catalogo:
        <q-select
          v-model="filtros.catalogoUuid"
          option-label="nome"
          option-value="catalogoUuid"
          :options="catalogoList"
          dense
          map-options
          emit-value
          class="input-new-design"
          outlined
        />
      </div>

      <div class="q-ml-sm col-md-2">
        Usuario Nome:
        <q-input
          class="input-new-design"
          v-model="filtros.usuarioId"
          dense
          outlined
        />
      </div>
      <div class="q-ml-sm col-md-2">
        Data Inicial:
        <q-input
          v-model="filtros.dataInicial"
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataInicial"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="q-ml-sm col-md-3">
        Data Final:
        <q-input
          v-model="filtros.dataFinal"
          dense
          outlined
          class="input input-new-design"
          placeholder="DD/MM/AAAA"
          mask="##/##/####"
        >
          <template v-slot:append>
            <q-icon name="event" class="cursor-pointer">
              <q-popup-proxy
                cover
                transition-show="scale"
                transition-hide="scale"
              >
                <q-date
                  v-model="filtros.dataFinal"
                  :locale="myLocale"
                  mask="DD/MM/YYYY"
                >
                  <div class="row items-center justify-end">
                    <q-btn v-close-popup label="Fechar" color="primary" flat />
                  </div>
                </q-date>
              </q-popup-proxy>
            </q-icon>
          </template>
        </q-input>
      </div>
      <div class="q-ml-sm col-md-2 q-mt-sm">
        Linhas por Pagina:
        <q-input
          class="input-new-design"
          v-model="filtros.perPage"
          dense
          outlined
          type="number"
        />
      </div>
    </div>

    <div>
      <q-table
        flat
        table-header-class="bg-accent text-width-bold"
        :rows="rows"
        :loading="disable"
        dense
        :columns="columns"
        class="tabela-tamanho-fixo q-mt-md"
        :rows-per-page-options="[0]"
        hide-pagination
        row-key="name"
      >
        <template v-slot:top-right>
          <!--<q-input
              outlined
              rounded
              dense
              debounce="300"
              v-model="filter"
              placeholder="Filtrar por nome"
            >
              <template v-slot:append>
                <q-icon name="search" />
              </template>
            </q-input>-->
        </template>
        <template v-slot:no-data="props">
          <div
            v-if="props"
            style="background-color: transparent"
            class="full-width row flex-center q-gutter-sm q-mt-sm"
          >
            <q-img
              src="./../../../assets/tabelSemDados.svg"
              style="height: 170px; width: 150px"
            />
          </div>
        </template>
        <template v-slot:top-left>
          <span
            style="
              font-size: 16px;
              display: block;
              margin-left: -15px;
              color: #21324a;
            "
            >Todos os Logs: {{ logsQuantidade }}</span
          >
        </template>

        <template #body-cell-updated_at="props">
          <q-td>
            <div class="q-pl-sm">
              {{ props.row.updated_at }}
            </div>
          </q-td>
        </template>
        <template #body-cell-url="props">
          <q-td style="white-space: normal">
            <q-btn
              no-caps
              class="btn-grid-finalizacao text-brand-1"
              flat
              icon="link"
              @click="assinarRelatorio(props.row.url)"
            />
          </q-td>
        </template>
        <template #body-cell-verLog="props">
          <q-td>
            <q-btn
              no-caps
              class="btn-grid-finalizacao"
              flat
              style="color: #3c76f1"
              icon="sym_o_article"
              @click="detalharLog(props.row.logId)"
            />
          </q-td>
        </template>
      </q-table>
    </div>
    <q-dialog v-model="verLog">
      <q-card>
        <q-card-section> </q-card-section>

        <q-card-section class="q-pt-none">
          <vue-json-pretty :data="log" />
        </q-card-section>

        <q-card-actions align="right">
          <q-btn flat label="OK" color="primary" v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </q-page>
</template>

<script>
const columns = [
  {
    name: "unidadeNome",
    label: "Unidade do Upload",
    field: "unidadeNome",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "catalogoNome",
    label: "Nome Catalogo",
    field: "catalogoNome",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "usuarioNome",
    label: "Usuário que fez o upload",
    field: "usuarioNome",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "usuarioMatricula",
    label: "Matricula ",
    field: "usuarioMatricula",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "dataExecucao",
    label: "Data e Hora upload",
    field: "dataExecucao",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "tipo",
    label: "Tipo Planilha",
    field: "tipo",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "url",
    label: "Baixar Planilha",
    field: "url",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "nLinhas",
    label: "Nº Linhas",
    field: "nLinhas",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "nErros",
    label: "Nº Erros",
    field: "nErros",
    align: "left",
    style: "white-space: normal",
  },
  {
    name: "verLog",
    label: "Detalhes do Log",
    field: "verLog",
    align: "left",
    style: "white-space: normal",
  },
];

import { useStore } from "vuex";
import { useQuasar } from "quasar";
import { useRouter } from "vue-router";
import { watchDebounced } from "@vueuse/core";
import { ref, onMounted, computed } from "vue";
import VueJsonPretty from "vue-json-pretty";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";

import "vue-json-pretty/lib/styles.css";
export default {
  components: { VueJsonPretty, ListaUnidadesSelect },
  setup() {
    const store = useStore();
    const rows = ref([]);
    const unidade = ref();
    const quasar = useQuasar();
    const router = useRouter();
    const disable = ref(true);

    const verLog = ref(false);
    const log = ref(null);
    const logsQuantidade = ref(0);
    const catalogoEspecificoUuid = ref(null);
    const filtros = ref({
      perPage: 15,
      catalogoUuid: null,
      dataInicial: null,
      dataFinal: null,
      usuarioId: null,
    });
    const catalogoList = ref([]);
    const pagination = ref({
      sortBy: "desc",
      descending: false,
      page: 1,
      rowsPerPage: 10,
      rowsNumber: 15,
    });
    const getDados = async (page = 1) => {
      try {
        console.log(filtros.value.usuarioId);
        let response = await store.dispatch("ferramentaria/logsSetup", {
          page: page,
          per_page: filtros.value.perPage,
          unidadeId: unidade.value?.id,
          catalogoUuid: filtros.value.catalogoUuid,
          dataInicial: filtros.value.dataInicial
            ?.split("/")
            ?.reverse()
            ?.join("-"),
          dataFinal: filtros.value?.dataFinal?.split("/")?.reverse()?.join("-"),
          usuarioId: filtros.value?.usuarioId,
        });

        rows.value = response.data.resultado.dados;

        pagination.value.rowsPerPage = response.data.resultado.perPage;
        pagination.value.page = response.data.resultado.currentPage;
        pagination.value.rowsNumber = response.data.resultado.total;
        logsQuantidade.value = response.data.resultado.total;
        disable.value = false;
      } catch (error) {
        quasar.notify({
          message: "Erro a o procurar dados",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };

    onMounted(getDados);

    const routeNotificacao = async () => {
      router.push({
        name: "configuracao-logs-lista-notificacao",
      });
    };

    watchDebounced(
      [
        () => filtros.value.perPage,

        () => filtros.value.resource_id,

        () => filtros.value.level,

        () => filtros.value.user_name,
        () => filtros.value.data_final,
        () => filtros.value.data_inicial,
      ],
      () => {
        if (
          filtros.value.data_inicial != "" &&
          filtros.value.data_inicial.length != 10
        ) {
          return;
        }
        if (
          filtros.value.data_final != "" &&
          filtros.value.data_final.length != 10
        ) {
          return;
        }
        getDados(pagination.value.page, +filtros.value.perPage);
      },
      { debounce: 400 }
    );

    watchDebounced(
      () => [
        filtros.value.catalogoUuid,
        filtros.value.usuarioId,
        filtros.value.dataInicial,
        filtros.value.dataFinal,
        filtros.value.perPage,
      ],
      () => {
        getDados();
      },
      { debounce: 400 }
    );

    watchDebounced(
      () => store.state.org.unidadeData,
      () => {
        unidade.value = store.state.org.unidadeData;
        getDados();
      },
      { debounce: 400 },
      { deep: true }
    );

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        unidade.value = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    const receberCatalogoEspecifico = (value) => {
      catalogoEspecificoUuid.value = value;
    };

    const selecionarCatalogoEspecifico = async () => {
      try {
        const response = await store.dispatch("ferramentaria/listarCatalogo", {
          unidadeId: unidade.value?.id,
          page: 1,
          perPage: 10,
        });
        if (response.response.data.resultado?.dados.length == 0) {
          return;
        }
        catalogoList.value = response.response.data.resultado.dados;
      } catch (error) {
        console.log(error);
      }
    };

    onMounted(selecionarCatalogoEspecifico);

    const detalharLog = (logId) => {
      router.push({
        name: "ferramentaria-logs-setup-detalhe",
        params: { id: logId },
      });
    };

    const assinarRelatorio = async (fileUrl) => {
      try {
        const response = await store.dispatch("notificacao/assinarRelatorio", {
          fileUrl,
        });

        let relatorioAssinado = response.data.resultado.dados;

        // Remove aspas extras (caso existam)

        window.open(relatorioAssinado, "_blank");
      } catch (error) {
        quasar.notify({
          message: "Erro ao gerar url do relatório",
          color: "negative",
          actions: [
            {
              label: "Fechar",
              color: "white",
              handler: () => {
                /* ... */
              },
            },
          ],
        });
      }
    };
    return {
      rows,
      columns,
      getDados,
      tipoDocumento: [
        { id: 0, nome: "FICHA DE EPI", value: "ficha_epi" },
        { id: 1, nome: "RELATÓRIOS", value: "relatorio" },
        { id: 2, nome: "Consumo", value: "consumo" },
      ],
      myLocale: {
        /* starting with Sunday */
        days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
        daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
        months:
          "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
            "_"
          ),
        monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split(
          "_"
        ),
        firstDayOfWeek: 1,
      },
      pagination,
      disable,
      detalharLog,
      pagesNumber: computed(() =>
        Math.ceil(pagination.value.rowsNumber / pagination.value.rowsPerPage)
      ),
      logsQuantidade,
      routeNotificacao,
      verLog,
      receberCatalogoEspecifico,
      log,
      filtros,
      assinarRelatorio,
      unidade,
      catalogoList,
    };
  },
};
</script>

<style scoped>
p {
  margin: 0;
}

.button-link {
  cursor: pointer;
  color: #0000ff;
  text-decoration: underline;
}
</style>
